<div class="mat-form-field-container select-search" #mffContainer>
  @if (!native) {
    <mat-form-field class="select-primary" [floatLabel]="'auto'" [ngClass]="{ 'select-open': select.panelOpen }">
      <span
        class="select-arrow"
        [inlineSVG]="'/icons/icon-arrow-' + (select.panelOpen ? 'up' : 'down') + '.svg'"
      ></span>
      <mat-select
        #select
        [(ngModel)]="value"
        disableOptionCentering
        panelClass="select-options-primary"
        [placeholder]="'global.select' | transloco"
        (selectionChange)="onValueChange($event)"
      >
        <input
          type="text"
          [placeholder]="'global.search' | transloco"
          class="search-input"
          [(ngModel)]="searchQuery"
          (ngModelChange)="onSearch($event)"
        />
        @if (optionsFiltered && optionsFiltered.length === 0) {
          <mat-option [ngStyle]="{ width: mffContainer.getBoundingClientRect().width - 1 + 'px' }">
            <div class="text-center text-muted text-italic">No Data</div>
          </mat-option>
        }
        @if (optionsFiltered.length > 0) {
          @for (option of optionsFiltered; track option) {
            <mat-option
              [value]="option.value"
              [ngStyle]="{ width: mffContainer.getBoundingClientRect().width - 1 + 'px' }"
            >
              @if (translate) {
                {{ option.key | transloco }}
              } @else {
                {{ option.key }}
              }
            </mat-option>
          }
        }
      </mat-select>
      @if (errors) {
        <div class="mat-error">
          @if (errors.required) {
            {{ 'form.error.required' | transloco }}
          }
        </div>
      }
    </mat-form-field>
  }

  @if (native) {
    <mat-form-field class="select-primary" [floatLabel]="'auto'">
      <span class="select-arrow" [inlineSVG]="'/icons/icon-arrow-down.svg'"></span>
      <select
        #select
        matNativeControl
        [(ngModel)]="value"
        [placeholder]="'global.select' | transloco"
        (change)="onValueChange($event, true)"
      >
        @for (option of options; track option) {
          <option [value]="option.value">
            @if (translate) {
              {{ option.key | transloco }}
            } @else {
              {{ option.key }}
            }
          </option>
        }
      </select>
      @if (errors) {
        <div class="mat-error">
          @if (errors.required) {
            {{ 'form.error.required' | transloco }}
          }
        </div>
      }
    </mat-form-field>
  }
</div>
